// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RunGroupOut = zod.object({
  "avg_latency_ms": zod.union([zod.int(),zod.null()]),
  "cost_usd": zod.string(),
  "failed": zod.int(),
  "key": zod.string(),
  "label": zod.string(),
  "runs": zod.int(),
  "tokens_input": zod.int(),
  "tokens_output": zod.int()
});

export type RunGroupOut = zod.input<typeof RunGroupOut>;
export type RunGroupOutOutput = zod.output<typeof RunGroupOut>;
